<div class="thought-trail">
    <div class="trail-head-row">
        <ng-content></ng-content>
        <span
            class="trail-header"
            role="button"
            tabindex="0"
            [attr.aria-expanded]="!collapsed"
            (click)="onToggle()"
            (keydown.enter)="onToggle()"
            (keydown.space)="$event.preventDefault(); onToggle()">
            <span class="header-label">
                <ng-container *ngIf="streaming">Thinking…</ng-container>
                <ng-container *ngIf="!streaming">
                    <ng-container *ngIf="elapsedSeconds !== null; else processFallback">
                        Thought for {{ elapsedSeconds }}s
                    </ng-container>
                    <ng-template #processFallback>Thought process</ng-template>
                </ng-container>
            </span>
            <i
                class="ph-bold trail-caret"
                [class.ph-caret-down]="!collapsed"
                [class.ph-caret-up]="collapsed"
                aria-hidden="true"></i>
        </span>
    </div>

    <div class="trail-body" *ngIf="!collapsed && (thoughts.length > 0 || thinkingRows.length > 0)">
        <!-- Reasoning paragraphs (from ai.stream.thinking-delta) — each paragraph -->
        <!-- becomes a row with a check icon, matching Figma 1389:20396. Last     -->
        <!-- reasoning row drops its connector ONLY if no tool-call rows follow.  -->
        <div
            *ngFor="let row of thinkingRows; let last = last; let i = index; trackBy: trackByIndex"
            class="thought-row"
            [class.is-last]="last && thoughts.length === 0">
            <div class="row-rail">
                <i class="ph-bold ph-check-circle row-icon icon-muted mt-1 icon-16" aria-hidden="true"></i>
                <span
                    *ngIf="!(last && thoughts.length === 0)"
                    class="rail-connector"></span>
            </div>
            <p class="row-label">{{ row }}</p>
        </div>

        <div
            *ngFor="let t of thoughts; let last = last; trackBy: trackById"
            class="thought-row"
            [class.is-last]="last">
            <div class="row-rail">
                <i
                    *ngIf="t.ok === undefined"
                    class="ph-bold ph-circle-notch row-icon icon-placeholder mt-1 icon-16 spinning"
                    aria-hidden="true"></i>
                <i
                    *ngIf="t.ok === true"
                    class="ph-bold ph-check-circle row-icon icon-muted mt-1 icon-16"
                    aria-hidden="true"></i>
                <i
                    *ngIf="t.ok === false"
                    class="ph-bold ph-x-circle row-icon icon-error mt-1 icon-16"
                    aria-hidden="true"></i>
                <span *ngIf="!last" class="rail-connector"></span>
            </div>
            <p class="row-label">{{ t.label }}</p>
        </div>

    </div>
</div>
